import { normalizeSeverity } from '../constants/colors';
import { getRiskLevel } from './risk';
import { matchesDateFilter } from './format';

export function applyRecordFilters(records, {
  dateFilter,
  activeCompanies = [],
  categoryFilter = '',
  severityFilter = '',
  riskLevel = '',
  trackedCompanies,
  searchText = '',
}) {
  const severity = severityFilter || (riskLevel && riskLevel !== 'all' ? riskLevel : '');
  const search = searchText.trim().toLowerCase();

  return records.filter(r => {
    if (!matchesDateFilter(r.published_at, dateFilter)) return false;

    if (trackedCompanies?.size > 0 && !trackedCompanies.has(r.company)) return false;
    if (activeCompanies.length > 0 && !activeCompanies.includes(r.company)) return false;

    if (categoryFilter && !(r.categories || []).includes(categoryFilter)) return false;

    if (search) {
      const haystack = [r.company, r.title, r.snippet, r.summary, r.content, r.source_domain]
        .map(value => String(value || '').toLowerCase())
        .join(' ');
      if (!haystack.includes(search)) return false;
    }

    if (severity) {
      const level = getRiskLevel(r.severity);
      if (severity === 'high' && level !== 'high') return false;
      if (severity === 'medium' && level !== 'medium') return false;
      if (severity === 'low' && level !== 'low') return false;
      if (!['high', 'medium', 'low'].includes(severity)
        && normalizeSeverity(r.severity) !== severity) return false;
    }

    return true;
  });
}

export function sortRecords(records, sortOrder = 'newest') {
  return [...records].sort((a, b) => {
    const diff = new Date(b.published_at || 0) - new Date(a.published_at || 0);
    return sortOrder === 'newest' ? diff : -diff;
  });
}